import { useTranslation } from "react-i18next";
import { Button, Modal } from "react-bootstrap";
import { getFirstLetterOfName } from "../../../../../../Utils";
import { useEffect, useMemo, useState } from "react";
import { GET_USER_LIST_URL } from "Constant/api";
import { newAuthService } from "Service/Axios";
import { LoadingComponent } from "Components";
import { toast } from "react-toastify";

export const SpecialGuestModal = ({
  show,
  selectGuestIds,
  toggle,
  handleChangeSpecialGuest,
}) => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState("");
  const [userList, setUserList] = useState([]);

  const searchedUserList = useMemo(() => {
    if (search && search.length > 0) {
      return userList?.filter((user) =>
        user.fullName?.toLowerCase().includes(search.toLowerCase())
      );
    }
    return userList;
  }, [userList, search]);

  // Listing
  const fetchUserList = async () => {
    try {
      const response = await newAuthService(GET_USER_LIST_URL, "POST", {});
      if (response.status) {
        const updatedUserList = response.data.map((user) => {
          if (selectGuestIds.includes(user.userId)) {
            return { ...user, checked: true };
          }
          return { ...user };
        });
        setUserList(updatedUserList);
      } else {
        setUserList([]);
      }
    } catch (error) {
      toast.error("Error fetching user list:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUserList();
  }, [selectGuestIds]);

  // On Change
  const handleChangeUser = (e, userId) => {
    const updatedUserList = userList.map((user) => {
      if (user.userId === userId) {
        return { ...user, checked: e.target.checked };
      }
      return { ...user };
    });
    setUserList(updatedUserList);
  };

  const handleSearchAssigne = (e) => {
    setSearch(e.target.value);
  };

  // Submit & Reste
  const onSaveSpecialGuest = () => {
    const updatedUserList = userList.filter((user) => user.checked);
    handleChangeSpecialGuest(updatedUserList);
    toggle();
  };

  return (
    <Modal
      size="md"
      show={show}
      onHide={toggle}
      centered
      backdrop="static"
      keyboard={false}
    >
      <Modal.Header closeButton>
        <Modal.Title className="text-md text-slate-600">Add Guests</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <LoadingComponent isLoading={loading}>
          <ul className="list-unstyled">
            <li>
              <div className="search-div mb-2">
                <div className="input-group">
                  <button type="button" className="input-group-text">
                    <i className="pluto-search"></i>
                  </button>
                  <input
                    type="search"
                    className="form-control"
                    placeholder={t("common.placeHolder.searchGuest")}
                    value={search}
                    onChange={handleSearchAssigne}
                  />
                </div>
              </div>
            </li>
            <li className="assignee-list-date">
              <ul className="list-unstyled d-flex flex-column row-gap-2 max-h-300 overflow-y-auto pe-1">
                {searchedUserList &&
                  searchedUserList.length > 0 &&
                  searchedUserList.map((user, index) => (
                    <li className="assignee-item" key={index.toString()}>
                      <div className="d-flex align-items-center">
                        <div className="me-2 w-8 h-8 rounded-circle overflow-hidden">
                          {user.photoURL ? (
                            <img
                              src={user.photoURL}
                              alt={`${user.firstName}${user.lastName}`}
                              className="w-100 h-100 object-fit-cover"
                            />
                          ) : (
                            getFirstLetterOfName(user)
                          )}
                        </div>
                        <span className="text-xs font-medium text-slate-500">
                          {user.firstName} {user.lastName}
                        </span>

                        <input
                          type="checkbox"
                          className="form-check-input ms-auto"
                          checked={user.checked}
                          onChange={(e) => handleChangeUser(e, user.userId)}
                        />
                      </div>
                    </li>
                  ))}
              </ul>
            </li>
          </ul>
        </LoadingComponent>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onSaveSpecialGuest}>
          {t("common.button.save")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
